import React, {Component} from 'react'
import { money } from '../../utils/helpers'

class ReturnItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      item: props.item,
    }
    this.updateOrder.bind(this)
  }
  updateOrder = () => {
    const dump = this.props.order
    dump.line_items.forEach(item => {
      if(item.id == this.state.item.id) {
        item.selectedAsReturn = this.state.item.selectedAsReturn
        item.returnReason = this.state.item.returnReason
        item.additionalReason = this.state.item.additionalReason
        item.returnQty = this.state.item.returnQty || 0
      }
    })
    this.props.updateOrder(dump)
  }
  
  updateItem = (item) => {
    this.setState({ item, })
    setTimeout(() => {
      this.updateOrder()
    }, 150)
  }

  render() {
    return (
      <div className='grid lg:grid-cols-2 gap-5 lg:gap-6.25'>
        <div className='grid grid-cols-2 gap-5'>
          <div className='flex items-center'>
            <label
              htmlFor={`lineItem-${this.state.item.id}`}
              className="checkbox-wrapper mr-7"
            >
              <input
                type="checkbox"
                className='!w-5.25 !h-5.25 !mr-0'
                name="lineItem"
                value="By Courier"
                checked={ !!this.state.item.selectedAsReturn }
                id={`lineItem-${this.state.item.id}`}
                onChange={e => { this.updateItem(Object.assign(this.state.item, { selectedAsReturn: e.target.checked, returnQty: e.target.checked ? Math.max((this.state.item.returnQty || 0), 1) : 0 })) }}
              />
            </label>
            { this.state.item.image &&
              <div className='grow'>
                <img src={this.state.item.image + '&width=240'} className='w-full h-auto block' alt={this.state.item.title} /> 
              </div>
            }
          </div>
          <div className={`flex flex-col gap-2.5 ${this.state.item.image ? '' : 'col-span-2'}`}>
            <div>{ this.state.item?.product?.title || this.state.item.title }</div>
            <div>
              {window.productStrings.size}:&nbsp;
              { this.state.item.variant?.option2 }
            </div>
            <div>
              {window.productStrings.color}:&nbsp;
              { this.state.item.variant?.option1 }
            </div>
            <div>
              {window.currencySymbol}{ parseFloat(this.state.item.final_line_price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }
              {
                parseFloat(this.state.item.original_line_price) > parseFloat(this.state.item.final_line_price) && <del className='ml-2'>{window.currencySymbol}{ parseFloat(this.state.item.original_line_price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }</del>
              }
            </div>
            
            <div className='flex items-center'>
              {window.productStrings.qty}:&nbsp;
              <div className='flex items-center'>
                <button className={`font-bold	cursor-pointer flex items-center justify-center w-6 h-6 ${this.state.item.returnQty < 1 || !this.state.item.returnQty ? 'opacity-50 pointer-events-none' : ''}`} 
                  aria-label='Decrease the return item quantity'
                  disabled={this.state.item.returnQty < 1 || !this.state.item.returnQty}
                  onClick={e => {
                    const newQty = this.state.item.returnQty - 1
                    this.updateItem(Object.assign(this.state.item, { returnQty: newQty, selectedAsReturn: newQty > 0 }))
                  }}
                >
                  &ndash;
                </button>
                <span className='w-6 h-6 border border-black flex items-center justify-center'>
                  { this.state.item.returnQty || 0 }
                </span>
                <button className={`font-bold	cursor-pointer flex items-center justify-center w-6 h-6 ${this.state.item.returnQty == this.state.item.currentQuantity ? 'opacity-50 pointer-events-none' : ''}`} 
                  aria-label='Increase the return item quantity'
                  disabled={this.state.item.returnQty == this.state.item.currentQuantity}
                  onClick={e => {
                    const newQty = (this.state.item.returnQty || 0) + 1
                    this.updateItem(Object.assign(this.state.item, { returnQty: newQty, selectedAsReturn: newQty > 0 })) 
                  }}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className='select-wrap mb-10'>
            <label htmlFor=''>{window.accountStrings.reasons.title}</label>
            <select 
              defaultValue={this.state.item.returnReason}
              onChange={e => { this.updateItem(Object.assign(this.state.item, { returnReason: e.target.value })) }}
            >
              {
                [window.accountStrings.reasons.title].concat(window.accountStrings.reasons.list).map((reason, index) =>
                  <option value={index == 0 ? null : reason.trim()} key={`reason-index-${this.state.item.id}-${index}`}>
                    {reason.trim()}
                  </option>
                )
              }
            </select>
          </div>
          <div className='input-wrap'>
            <textarea 
              id={`returnReasonAddtional-${this.state.item.id}`} 
              placeholder={window.accountStrings.reasons.furtherInfo}
              defaultValue={this.state.item.additionalReason}
              onChange={e => { this.updateItem(Object.assign(this.state.item, { additionalReason: e.target.value })) }}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }}
            />
            <label htmlFor={`returnReasonAddtional-${this.state.item.id}`}>
              {window.accountStrings.reasons.furtherInfo}
            </label>
          </div>
        </div>
      </div>
    )
  }
}

export default ReturnItem